<template>
    <Card>
        <FetchTable :handle="tableHandle" :columns="table.columns" :url="table.url" v-model:orders="table.orders">
            <template #td-user="{row}">
                {{ row.user.full_name }}
            </template>
            <template #td-amount="{row}">
                <span :class="row.amount > 0 ? 'text-success' : 'text-danger'">{{ Price.factory(row.amount).toCurrencyString(CustomCurrencyEnum.UAH) }}</span>
            </template>
            <template #td-reason="{row}">
                <div class="long-string" :title="row.reason">{{ row.reason }}</div>
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";
import DateFormatter from "../../../../services/DateFormatter";
import Price from "../../../../services/Price/Price";
import { CustomCurrencyEnum } from "../../../../services/Enum/CustomCurrencyEnum";

export default {
    name: "AiTransactionsIndexPage",
    components: {
        Card, FetchTable
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            Price,
            CustomCurrencyEnum,
            table: {
                url: `/projects/${this.$route.params.projectUuid}/core/ai-transactions`,
                orders: [{
                    column: 'created_at',
                    dir: 'desc'
                }],
                columns: [
                    { key: 'id', name: this.$t('table.titles.id'), width: '100px', type: 'string', order: true },
                    { key: 'reason', name: this.$t('labels.reason'), width: 'auto', type: 'string', order: false },
                    { key: 'user', name: this.$t('labels.user'), width: '250px', type: 'string', order: false },
                    { key: 'amount', name: this.$t('labels.tokens_amount'), width: '250px', type: 'string', order: false },
                    { key: 'created_at', name: this.$t('table.titles.created_at'), width: '250px', type: 'string', order: true },
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows();
    }
}
</script>
<style scoped>
.long-string {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
